import { render, staticRenderFns } from "./AppProgramaModeradores.vue?vue&type=template&id=44fff9f6&scoped=true&"
import script from "./AppProgramaModeradores.vue?vue&type=script&lang=ts&"
export * from "./AppProgramaModeradores.vue?vue&type=script&lang=ts&"
import style0 from "./AppProgramaModeradores.vue?vue&type=style&index=0&id=44fff9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fff9f6",
  null
  
)

export default component.exports